import { motion } from "framer-motion";

/**
 * Reveal — pembungkus animasi scroll-reveal yang halus & profesional.
 * Restrained motion: fade + naik sedikit, sekali saja (once).
 */
export const Reveal = ({ children, delay = 0, y = 24, className = "", as }) => {
  const MotionTag = as ? motion[as] : motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
